<app-base-sidebar [sidebarTitle]="sidebarTitle()" (close)="sidebarRef.requestClose()" [noPadding]="true" sizeClass="size-34">
	@if (!loading()) {
		<app-table
			[model]="tableModel()"
			(rowClick)="openLeerlingDetails($event)"
			[sortDirection]="sidebarSortOrder().direction"
			[sortActive]="sidebarSortOrder().active"
			sortQueryParam="sidebarSortOrder"
		></app-table>
	} @else if (spinnerDelay | async) {
		<app-css-spinner></app-css-spinner>
	}
</app-base-sidebar>
